import { EVENT_SOURCE, SEARCH_DIALOG_EVENT_SOURCE } from '../../constants/analytics';
import type { SearchStoreExperience } from '../../constants/search';
import { SearchExperience } from '../../constants/search-experience';
import type { FireAnalyticsEvent } from '../../types';

type OnSmartLinkUsageAndTopAppsFetchSuccessArgs = {
	cloudId: string;
	experience: SearchStoreExperience;
	percentage: number;
	mostUsedApps: string[];
};

// Fires when the Smart Link usage and top apps trait is successfully fetched from the TAP delivery API
export const onSmartLinkUsageAndTopAppsFetchSuccess = ({
	cloudId,
	experience,
	percentage,
	mostUsedApps,
}: OnSmartLinkUsageAndTopAppsFetchSuccessArgs): FireAnalyticsEvent => {
	return {
		action: 'taskSuccess',
		actionSubject: 'smartLinkUsageAndTopAppsFetch',
		eventType: 'operational',
		source: experience === SearchExperience.QUICK_FIND ? SEARCH_DIALOG_EVENT_SOURCE : EVENT_SOURCE,
		attributes: {
			additionalAttributes: {
				cloudId,
				percentage,
				topAppCount: mostUsedApps.length,
				mostUsedApps: JSON.stringify(mostUsedApps),
			},
		},
	};
};

type OnSmartLinkUsageAndTopAppsFetchFailArgs = {
	cloudId: string;
	experience: SearchStoreExperience;
	reason: string;
};

// Fires when the Smart Link usage and top apps trait fetch from the TAP delivery API fails
export const onSmartLinkUsageAndTopAppsFetchFail = ({
	cloudId,
	experience,
	reason,
}: OnSmartLinkUsageAndTopAppsFetchFailArgs): FireAnalyticsEvent => {
	return {
		action: 'taskFail',
		actionSubject: 'smartLinkUsageAndTopAppsFetch',
		eventType: 'operational',
		source: experience === SearchExperience.QUICK_FIND ? SEARCH_DIALOG_EVENT_SOURCE : EVENT_SOURCE,
		attributes: {
			additionalAttributes: {
				cloudId,
				reason,
			},
		},
	};
};
